import React, {useState} from "react";
import { FileMetadata, FileMetadataTypeEnum} from "../../gen/api";
import {List, ListItem} from "@mui/material";
import FormService from "../../services/file.service";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../store";
import {setErrorMessage} from "../../store/reducers/message";
import ActionDialog from "../ActionDialog/ActionDialog";
import FileDownload from "../Files/FileDownload";
import FileUpload from "../Files/FileUpload";
import DeleteButton from "../DeleteButton/DeleteButton";

type Props = {

  forms: FileMetadata[]
  handleNewFormSubmit: (form: FileMetadata) => void
  handleDeleteForm: (formId: string) => void
}

function FilesEdit({
                        forms,
                        handleNewFormSubmit,
                        handleDeleteForm
                      }: Props) {
  const [deleteFormModalOpen, setDeleteFormModalOpen] = useState(false);
  const [form, setForm] = useState<FileMetadata>();
  const dispatch = useDispatch<AppDispatch>();

  function deleteForm(formId: string | undefined) {
    if (!formId) return;
    FormService.deleteFile(formId).then(_ => {
          handleDeleteForm(formId);
          setDeleteFormModalOpen(false);
        }
    ).catch(_ => {
          dispatch(setErrorMessage("Das Formular konnte nicht gelöscht werden. Bitte versuchen Sie es später erneut."));
          setDeleteFormModalOpen(false);
        }
    );
  }

  return (
      <>
        <List>
          {forms.map(form =>
              <ListItem key={form.id}>
                <FileDownload form={form}/>
                <DeleteButton onClick={_ => {
                  setForm(form);
                  setDeleteFormModalOpen(true);
                }}/>
              </ListItem>)
          }
          <ListItem>
            <FileUpload fileType={FileMetadataTypeEnum.Form}
                        handleNewFormSubmit={handleNewFormSubmit}/>
          </ListItem>
        </List>
        <ActionDialog isOpen={deleteFormModalOpen}
                      onConfirm={() => deleteForm(form?.id)}
                      onClose={() => setDeleteFormModalOpen(false)}
                      title="Formular löschen"
                      message="Möchten Sie das Formular wirklich löschen?"/>
      </>
  );
}

export default FilesEdit;